module.exports = __webpack_public_path__ + "img/carrefour_frontenac.78f0b1c9.png";